import { set_shop } from '@actions/shop'
import { whoami } from '@apis/_shop'
import { ACTION_TYPES } from '@bundles/stores/reducers/action'
import { useContext } from '@bundles/utils/context'
import { useCallback, useEffect, useRef, useState } from 'react'

export const useShopData = () => {
  const [, rootDispatch] = useContext()
  const [shopInfo, setShopInfo] = useState<A>()
  const whoamiJustFetchedRef = useRef<string | null>(null)
  const whoamiRefetchedRef = useRef(false)
  const handleInitApp = useCallback(
    (response: A, isRefetch: boolean) => {
      rootDispatch({
        type: ACTION_TYPES.APP_LOAD_INITIAL_DATA,
        payload: response,
      })
      isRefetch && localStorage.setItem('whoami', JSON.stringify(response))

      rootDispatch(set_shop(response))
      setShopInfo(response)
    },
    [rootDispatch],
  )
  const { error , refetch } = whoami({
    enabled: false,
    onSuccess: data => {
      whoamiJustFetchedRef.current = JSON.stringify(data)
      handleInitApp(data, true)
    },
  })


  useEffect(() => {
    const raw = localStorage.getItem('whoami')
    if (raw) {
      if (
        whoamiJustFetchedRef.current !== null &&
        raw === whoamiJustFetchedRef.current
      ) {
        whoamiJustFetchedRef.current = null
        return
      }
      try {
        handleInitApp(JSON.parse(raw), false)
        if (!whoamiRefetchedRef.current) {
          whoamiRefetchedRef.current = true
          refetch?.()
        }
      } catch {
        localStorage.removeItem('whoami')
        refetch?.()
      }
    } else {
      whoamiRefetchedRef.current = true
      refetch?.()
    }
  }, [refetch, handleInitApp])
  return {
    shopInfo,
    error,
    // Computed values
    hasShopData: shopInfo !== null,
  }
}
